import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/index'
import { common } from '@/api/interface'
import { SHA256 } from '@/utils/util'

Vue.use(Vuex)

import login from './login'
// import auths from "./auths";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    async login({ commit }, { data }) {
      const res = await common.post('/user/genSalt', '', '')
      console.log(res)
      if (res.code === 200) {
        let userInfo = {}
        userInfo.loginName = data.loginName
        userInfo.timeStamp = res.data.rkey
        userInfo.password = SHA256(data.password + res.data.rvalue)
        const ret = await common.post('/user/login', '', userInfo)
        if (ret.code === 200) {
          commit('login/STORE_LOGINNAME', data.loginName)
          commit('login/STORE_PASSWORD', data.password)
          commit('login/STORE_TOKEN', ret.data.token)
          commit('login/STORE_TOKENEXPIRETIME', ret.data.expireTime)
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    async getResponse({ dispatch }, { func, url, params, data, holder }) {
      if (!url) return
      if (!params) params = {}
      if (!holder) {
        holder = []
      } else {
        // holder = JSON.stringify(holder)
      }
      if (!func) func = common.post
      if (func === 'get') func = common.get
      if (func === 'jsonPost') func = common.jsonPost
      let iterationTimes = 0 // 302循环次数
      return new Promise((resolve, reject) => {
        dispatch('responseHandler', {
          func,
          url,
          params,
          data,
          holder,
          iterationTimes
        })
          .then((res) => {
            resolve(res)
          })
          .catch((res) => {
            reject(res)
          })
      })
    },
    async responseHandler(
      { dispatch, state },
      { func, url, params, data, holder, iterationTimes }
    ) {
      return new Promise((resolve, reject) => {
        func(url, params, data)
          .then(async (res) => {
            if (res.code >= 200 && res.code < 300) {
              if (res.code === 204) {
                resolve({})
              } else {
                resolve(res.data)
              }
            } else if (res.code >= 300 && res.code < 400) {
              if (iterationTimes < 1) {
                let loginData = {
                  loginName: state.loginName,
                  password: state.password
                }
                await dispatch('login', { data: loginData })
                iterationTimes++
                dispatch('responseHandler', {
                  func,
                  url,
                  params,
                  data,
                  holder,
                  iterationTimes
                }).then((res) => {
                  resolve(res)
                })
              } else {
                resolve(holder)
                let hosturl = location.host
                let path = location.href.split(hosturl, 2)[1]
                router.push('/login?redirectUrl=' + encodeURIComponent(path))
              }
            } else {
              resolve(holder)
            }
          })
          .catch((res) => {
            resolve(holder)
            reject(res)
            console.log('store/action/responseHandler获取数据失败', res)
          })
      })
    }
  },
  modules: {
    login
    // auths,
  }
})
